import { parseAsString, useQueryStates } from "nuqs";

export function useStudySetParams() {
  const [params, setParams] = useQueryStates({
    q: parseAsString,
    subject: parseAsString.withDefault("all"),
  });

  return {
    ...params,
    setParams,
  };
}
